import React from 'react';

import Typography, { Props as TypographyProps } from '@smart-tv/components/typography/typography';

interface Props extends TypographyProps {}

export const PlayerInfoTitle: React.FC<Props> = (props: Props) => {
  const { children, ...rest } = props;

  return (
    <Typography variant="h1" component="h2" {...rest}>
      {children}
    </Typography>
  );
};

export default React.memo(PlayerInfoTitle);
